import { Component, OnDestroy, OnInit } from '@angular/core';
import { ImportService } from '../../../services/import.service';
import { THEME_VARIABLES } from '@alyle/ui';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pro-select-header',
  templateUrl: './pro-select-header.component.html',
  styleUrls: ['./pro-select-header.component.scss']
})
export class ProSelectHeaderComponent implements OnInit, OnDestroy {


  importTypes = [];
  importYears = [];
  importQuarters = [];

  importType: string;
  importYear: number;
  importQuarter: string;

  importTypeSubscription;
  importYearSubscription;
  importQuarterSubscription;

  private _subscriptions = new Subscription();

  constructor(private importService: ImportService, private router: Router) {

    this.importTypes = this.importService.importTypes;

    this.importYears = this.importService.importYears;
    
    this.importQuarters = this.importService.importQuarters;

   }

  ngOnInit() {
    console.log("ProSelectHeader init")

    this.importTypeSubscription = this.importService.importType$.subscribe((x) => {
      this.importType = x;
    });

    this.importYearSubscription = this.importService.importYear$.subscribe((x) => {
      this.importYear = x;
    });

    this.importQuarterSubscription = this.importService.importQuarter$.subscribe((x) => {
      this.importQuarter = x;
    });


    // //default to first option in list
    if (!this.importType) {
      this.importType = this.importTypes[0];
      this.setImportType();
    }
    
    //default to first option in list
    if (!this.importYear) {
      this.importYear = this.importYears[0];
      this.setImportYear();
    }
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  setImportType() {
    this.importService.setImportType(this.importType);
  }

  setImportYear() {
    this.importService.setImportYear(this.importYear);
  }

  setImportQuarter() {
    this.importService.setImportQuarter(this.importQuarter);
  }

  /**
   * For step 1 - shows the pro-import view
   */
  openProImport() {
    var variablesSet = this.importService.areAllImportVariablesSet();

    if(variablesSet){
      //navigate to import view
      this.router.navigate(['data/pro/import'])
    }
  }
}
